import { atom } from 'recoil';
import BeaconFilterItem from '../models/BeaconFilterItem';

const stateImgDiseases = atom({
  key: 'beacon.img.diseases',
  default: [] as BeaconFilterItem[],
});

export default stateImgDiseases;
